export const MIN_HEADER_HEIGHT = 60
export const INITIAL_HEADER_HEIGHT = 360
export const AMOUNT_TO_SCROLL_FOR_MIN_HEADER =
    INITIAL_HEADER_HEIGHT - MIN_HEADER_HEIGHT
